"use client";
import Card from "@/common/Card";
import Link from "next/link";
import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Mousewheel, Keyboard, Autoplay } from "swiper/modules";
import { useMutation } from "@tanstack/react-query";
import { getSearchProducts } from "@/services/productService";
import { ProductType } from "@/types/productType";
import LastOfferSkeleton from "@/components/Skeleton/LastOfferSkeleton";

function LastOffers() {
  const { isPending, mutateAsync: getProductsItem } = useMutation({
    mutationFn: getSearchProducts,
    retry: 2,
    retryDelay: 1000,
  });
  const [productData, setProductData] = useState<ProductType[]>([]);
  const getAllLastDiscountProduct = useCallback(async () => {
    try {
      const response = await getProductsItem({
        take: 10,
        lastDiscount: true,
      });
      if (response?.success) {
        setProductData(response?.products);
      }
    } catch (err) {
      console.log("error in fetch all data for last offers ", err);
    }
  }, [getProductsItem]);

  useEffect(() => {
    getAllLastDiscountProduct();
  }, [getAllLastDiscountProduct]);
  return (
    <>
      {productData?.length ? (
        <div className="overflow-hidden p-6  sm:p-10 pl-0 mx-0 lg:mx-16 my-5  lg:mt-20 bg-light-pink rounded-3xl flex items-center  min-h-96 flex-col pb-20 sm:pb-10 last-offer-swiper relative  sm:flex-row">
          <div className="self-start flex flex-col justify-between h-full w-full">
            <h3 className="farTv font-medium flex flex-row sm:flex-col text-ws-grayBlue-700 text-3xl sm:text-4xl h-auto  sm:h-96 w-full  sm:w-50 leading-12.5">
              <span>آفر های</span>
              <span>لحظه آخری</span>
            </h3>
            <Link className="text-ws-gray-500" href="/lastOfferList">
              <span className="underline underline-offset-[6px]	 text-lg more-btn absolute bottom-5  sm:relative">
                بیشتر
              </span>
            </Link>
          </div>

          <div className="cards-wrapper flex gap-3 justify-end mt-10 sm:mt-0">
            <Swiper
              cssMode={true}
              navigation={true}
              mousewheel={true}
              loop={false}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              keyboard={true}
              modules={[Navigation, Mousewheel, Keyboard, Autoplay]}
              slidesPerView={3}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },

                480: {
                  slidesPerView: 1.7,
                },
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 2.5,
                },
                870: {
                  slidesPerView: 2.5,
                },
                980: {
                  slidesPerView: 2.5,
                },
                1024: {
                  slidesPerView: 2.7,
                },
                1100: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 3.5,
                },
                1400: {
                  slidesPerView: 4,
                },
              }}
            >
              {isPending ? (
                <LastOfferSkeleton />
              ) : (
                productData?.map((product, index) => (
                  <SwiperSlide
                    className="w-75 swiper-slide-last-offer"
                    style={{ width: "300px" }}
                    key={index + 1}
                  >
                    <Card {...product} hasBuy={true} />
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default LastOffers;
